export class DownloadsDisabledError extends Error {
    constructor() {
        super('Downloads are disabled');
        this.name = 'DownloadsDisabledError';
    }
}
export class PdfUntrustedOriginError extends Error {
    constructor() {
        super('PDF downloads are restricted');
        this.name = 'PdfUntrustedOriginError';
    }
}
export class UserNotInFileOrgError extends Error {
    constructor() {
        super('This file belongs to a different organization');
        this.name = 'UserNotInFileOrgError';
    }
}
//# sourceMappingURL=errors.js.map